/**
 * Web 日志枚举定义
 *
 * @description Web 端错误和性能日志的枚举类型
 * @module @bayes-mes/shared/types/web-logs
 * @author YSFL Team
 * @date 2026-01-24
 */

// ============================================================================
// 错误类型枚举
// ============================================================================

/** 错误类型 */
export enum WebErrorType {
  /** JS 运行时错误 */
  JS_ERROR = 'js_error',
  /** Vue 组件错误 */
  VUE_ERROR = 'vue_error',
  /** Promise 拒绝 */
  PROMISE_ERROR = 'promise_error',
  /** 资源加载错误 */
  RESOURCE_ERROR = 'resource_error',
  /** API 请求错误 */
  API_ERROR = 'api_error',
}

/** 错误类型字面量 */
export type WebErrorTypeValue =
  | 'api_error'
  | 'js_error'
  | 'promise_error'
  | 'resource_error'
  | 'vue_error';

// ============================================================================
// 错误级别枚举
// ============================================================================

/** 错误级别 */
export enum WebErrorLevel {
  /** 致命 */
  FATAL = 'fatal',
  /** 错误 */
  ERROR = 'error',
  /** 警告 */
  WARNING = 'warning',
  /** 信息 */
  INFO = 'info',
}

/** 错误级别字面量 */
export type WebErrorLevelValue = 'error' | 'fatal' | 'info' | 'warning';

// ============================================================================
// 性能指标类型枚举
// ============================================================================

/** 性能指标类型 */
export enum WebMetricType {
  /** 页面加载 */
  PAGE_LOAD = 'page_load',
  /** API 请求 */
  API_REQUEST = 'api_request',
  /** 资源加载 */
  RESOURCE = 'resource',
  /** Web 核心指标 */
  WEB_VITALS = 'web_vitals',
  /** 内存 */
  MEMORY = 'memory',
}

/** 性能指标类型字面量 */
export type WebMetricTypeValue =
  | 'api_request'
  | 'memory'
  | 'page_load'
  | 'resource'
  | 'web_vitals';

// ============================================================================
// 用户行为枚举
// ============================================================================

/** 用户行为类型 */
export enum WebBehaviorActionType {
  PAGE_VIEW = 'page_view',
  PAGE_LEAVE = 'page_leave',
  CLICK = 'click',
  FORM_SUBMIT = 'form_submit',
  SEARCH = 'search',
  DOWNLOAD = 'download',
  EXPORT = 'export',
  PRINT = 'print',
  TAB_SWITCH = 'tab_switch',
  EXPAND = 'expand',
  SORT = 'sort',
  FILTER = 'filter',
}

/** 用户行为类型字面量 */
export type WebBehaviorActionTypeValue =
  | 'click'
  | 'download'
  | 'expand'
  | 'export'
  | 'filter'
  | 'form_submit'
  | 'page_leave'
  | 'page_view'
  | 'print'
  | 'search'
  | 'sort'
  | 'tab_switch';

/** 用户行为结果 */
export enum WebBehaviorActionResult {
  SUCCESS = 'success',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
  PENDING = 'pending',
}

/** 用户行为结果字面量 */
export type WebBehaviorActionResultValue =
  | 'cancelled'
  | 'failed'
  | 'pending'
  | 'success';

/** 用户时间线事件类型 */
export type WebTimelineEventType = 'all' | 'behavior' | 'error' | 'performance';

/** Web 告警级别 */
export type WebAlertLevel = 'critical' | 'info' | 'warning';
